import React from "react";
import MainBody from "./MainBody";
import SessionTimeoutModal from "./Modals/SessionTimeoutModal";
import ImpersonationProvider from "./Impersonation/ImpersonationProvider";
import "animate.css";

const AppContainer = React.memo((props) => {
  return (
    <ImpersonationProvider>
      <MainBody {...props} />
      <SessionTimeoutModal />
    </ImpersonationProvider>
  );
});

export default AppContainer;
